import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StatusContractEnum } from '@shared/enum/status-contract.enum';

@Component({
  selector: 'app-contracts-card-item',
  templateUrl: './contracts-card-item.component.html',
  styleUrls: ['./contracts-card-item.component.scss']
})
export class ContractsCardItemComponent implements OnInit {
  waitingForDocsProvider = StatusContractEnum.waitingForDocsProvider;
  waitingForDocsCustomer = StatusContractEnum.waitingForDocsCustomer;
  waitingForFinanceProvider = StatusContractEnum.waitingForFinanceProvider;
  waitingForFinanceCustomer = StatusContractEnum.waitingForFinanceCustomer;
  waitingForAcceptFinanceProvider = StatusContractEnum.waitingForAcceptFinanceProvider;
  waitingForAcceptDocsAdmin = StatusContractEnum.waitingForAcceptDocsAdmin;
  adminRejectedDocsCustomer = StatusContractEnum.adminRejectedDocsCustomer;
  adminRejectedDocsProvider = StatusContractEnum.adminRejectedDocsProvider;
  adminRejectedDocsBoth = StatusContractEnum.adminRejectedDocsBoth;
  waitingForContract = StatusContractEnum.waitingForContract;
  customerRequestforRevision = StatusContractEnum.customerRequestforRevision;
  providerRequestforRevision = StatusContractEnum.providerRequestforRevision;
  bothRequestForRevision = StatusContractEnum.bothRequestForRevision;
  customerRejectedContract =StatusContractEnum.customerRejectedContract;
  providerRejectedContract =StatusContractEnum.providerRejectedContract;
  waitingForContractUploadBoth = StatusContractEnum.waitingForContractUploadBoth;
  waitingForContractUploadCustomer = StatusContractEnum.waitingForContractUploadCustomer;
  waitingForContractUploadProvider =StatusContractEnum.waitingForContractUploadProvider;
  waitingForFinalApproveAdmin =StatusContractEnum .waitingForFinalApproveAdmin;
  waitingForAdminApproveProviderContract =StatusContractEnum.waitingForAdminApproveProviderContract;
  adminRejectedContractCustomer = StatusContractEnum.adminRejectedContractCustomer;
  adminRejectedContractProvider = StatusContractEnum.adminRejectedContractProvider;
  adminRejectedContractBoth = StatusContractEnum.adminRejectedContractBoth;
  waitingForSignatures = StatusContractEnum.waitingForSignatures;
  waitingForCustomerSignature =StatusContractEnum.waitingForCustomerSignature;
  waitingForProviderSignature =StatusContractEnum.waitingForProviderSignature;
  contractCompletion = StatusContractEnum.contractCompletion;
  contractCanceledByAdmin = StatusContractEnum.contractCanceledByAdmin;
  contractExpired = StatusContractEnum.contractExpired;
  id: number;
  @Input() providerInfo: any;
  @Input() customerInfo: any;
  @Input() goods: string;
  @Input() createdDate: string;
  @Input() contractNumber: string;
  @Input() status: any;
  @Input() Id: number;
  @Input() requestId: number;
  @Input() responseId: number;


  constructor(public router: Router) { }

  ngOnInit(): void {
  }
}
